module.exports = __webpack_public_path__ + "img/ByteArkLogo.9b839d68.png";